import { sharedConstants, sharedFilterHelpers } from 'shared-helpers';

export const FIELD_SEPARATOR = sharedConstants.FIELD_SEPARATOR;
export const EQUAL_SYMBOL = sharedConstants.EQUAL_SYMBOL;
export const VALUE_SEPARATOR = sharedConstants.VALUE_SEPARATOR;
export const DATE_FORMAT = sharedConstants.DATE_FORMAT;
export const ALLOWED_QUERY_OPERATOR = sharedConstants.ALLOWED_QUERY_OPERATOR;

// Helper methods
export const getFilterByKey = sharedFilterHelpers.getFilterByKey;
export const decodeFilters = sharedFilterHelpers.decodeFilters;
export const formatValue = sharedFilterHelpers.formatValue;
export const convertToUrl = sharedFilterHelpers.convertToUrl;
export const convertToFilterString = sharedFilterHelpers.convertToFilterString;
export const decodeFiltersValues = sharedFilterHelpers.decodeFiltersValues;